import { TPageSize } from "@elixir/types";
import RadioComponent from "../../atoms/radio-component";
import useReceiptCustomisationStore from "../../stores/receipt-customisation/receipt-customisation-store";
import {
  TColumnProperty,
  TColumnState,
} from "../../stores/receipt-customisation/types";

type TRadioOptionId = "show_always" | "when_applicable";
type TRadioOptionValues = "Show Always" | "When Applicable" | TPageSize;

export type TRadioOption = {
  id: TColumnState;
  label: TRadioOptionValues;
};

type ColumnSelection = {
  title: TColumnProperty;
  selectedId: TColumnState;
  options: Array<TRadioOption>;
  onClick: ({
    property,
    value,
  }: {
    property: TColumnProperty;
    value: TColumnState;
  }) => void;
  subtext?: string;
};

const options: Array<TRadioOption> = [
  {
    id: "ALWAYS",
    label: "Show Always",
  },
  {
    id: "IF_APL",
    label: "When Applicable",
  },
];

export const RadioInputSelector = ({
  title,
  selectedId,
  options,
  onClick,
  subtext,
}: ColumnSelection) => {
  return (
    <div className="space-y-4">
      <div className="flex justify-between items-center">
        {/* Body/Body 1/Regular */}
        <div className="text-14 font-400 leading-6 capitalize">
          {title?.split("_")?.join(" ")}
        </div>
        <div className="flex space-x-16">
          {options?.map((option) => (
            <RadioComponent
              key={option.id}
              isSelected={option.id === selectedId}
              label={option.label}
              onClick={() => onClick({ property: title, value: option.id })}
              labelClassName="text-14 font-400 leading-6"
            />
          ))}
        </div>
      </div>
      {subtext && selectedId === "IF_APL" ? (
        <div className="p-8 text-12 font-400 leading-4 bg-darwin-neutral-50 text-darwin-neutral-900 rounded-4">
          {subtext}
        </div>
      ) : null}
    </div>
  );
};

const ColumnsComponent = () => {
  const { columns, setColumns } = useReceiptCustomisationStore();

  const handleRadioInputClick = ({
    property,
    value,
  }: {
    property: TColumnProperty;
    value: TColumnState;
  }) => {
    setColumns({
      property,
      value,
    });
  };

  return (
    <div className="p-16">
      <div className="w-full flex items-center text-16 font-700 leading-8">
        Columns
      </div>
      <RadioInputSelector
        title="quantity"
        onClick={handleRadioInputClick}
        options={options}
        selectedId={columns.quantity}
        subtext="Quantity column will be added when it's greater than 1"
      />
      <RadioInputSelector
        title="discount"
        onClick={handleRadioInputClick}
        options={options}
        selectedId={columns.discount}
        subtext="Discount column will be shown only when a discount is applied"
      />
    </div>
  );
};

export default ColumnsComponent;
